
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inner-mysteries",
      function () {
        return require("private-next-pages/inner-mysteries/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inner-mysteries"])
      });
    }
  